import React from 'react';
import { Link } from 'react-router';
import { cn } from '~/lib/utils';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from './ui/language-switcher';

export function Footer({
  className,
  ...props
}: React.ComponentProps<'footer'>) {
  const year = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer
      className={cn('mt-auto w-full border-t py-6', className)}
      {...props}
    >
      <div className="container mx-auto flex flex-col items-center justify-between px-4 md:flex-row">
        <div className="text-sm">{t('footer.copyright', { year })}</div>
        <nav className="mt-4 flex items-center gap-6 text-sm md:mt-0">
          <Link
            to="/privacy"
            className="text-gray-600 hover:underline dark:text-gray-400"
          >
            {t('footer.privacy')}
          </Link>
          <Link
            to="/terms"
            className="text-gray-600 hover:underline dark:text-gray-400"
          >
            {t('footer.terms')}
          </Link>
          <div className="ml-1 flex items-center">
            <LanguageSwitcher />
          </div>
        </nav>
      </div>
    </footer>
  );
}
